import React, { useCallback, useEffect, useState } from "react";
import bgBody from "../Images/bg-body.png";
import bgBodyDark from "../Images/bg-body-2.png";
import { ErrorBoundary } from "react-error-boundary";
import { Routes, Route, Navigate, BrowserRouter } from "react-router-dom";
import { useSelector } from "react-redux";
import Analytics from "../Components/Home/Analytics";
import AuthRoutes from "./AuthRoutes";
import CRM from "../Components/Home/CRM";
import Project from "../Components/Home/Project";
import Ecommerce from "../Components/Home/Ecommerce";
import Helpdesk from "../Components/Home/Helpdesk";
import Inbox from "../Components/Leads/Inbox";
import LiveChat from "../Components/Leads/LiveChat";
import WebForms from "../Components/Leads//WebForms/WebForms";
import Prospector from "../Components/Leads/Prospector";
import WebVisitors from "../Components/Leads/WebVisitors";
import Messenger from "../Components/Leads/Messenger";
import Deals from "../Components/Deals/Deals";
import Projects from "../Components/Projects/Projects";
import Campaigns from "../Components/Campaigns/Campaigns";
import EmailCampaigns from "../Components/Campaigns/EmailCampaigns";
import AutomatedCampaigns from "../Components/Campaigns/AutomatedCampaigns";
import AboutPrice from "../Components/Campaigns/AboutPrice";
import FindHelp from "../Components/Campaigns/FindHelp";
import AlertsTips from "../Components/Campaigns/AlertsTips";
import Settings from "../Components/Campaigns/Settings";
import EmailTemplates from "../Components/Campaigns/EmailTemplates";
import Profile from "../Components/Pages/Profile";
import Tour from "../Components/Pages/Tour";
import Timeline from "../Components/Pages/Timeline";
import Treeview from "../Components/Pages/Treeview";
import Starter from "../Components/Pages/Starter";
import Pricing from "../Components/Pages/Pricing";
import Gallery from "../Components/Pages/Gallery";
import FAQs from "../Components/Pages/FAQs";
import Blogs from "../Components/Pages/Blogs";
import Products from "../Components/Products/Products";
import Marketplace from "../Components/Marketplace/Marketplace";
import People from "../Components/Contacts/People";
import Organizations from "../Components/Contacts/Organizations";
import AddWebForm from "../Components/Leads/WebForms/AddWebForm";
import Activitys from "../Components/Activitys/Activitys";
import AllForms from "../Components/Leads/WebForms/AllForms";
import InfoDetailsLeads from "../Components/Leads/infoDetailsLeads";
import DetailsOrganization from "../Components/Contacts/detailsOrganization";
import DetailsPeople from "../Components/Contacts/detailsPeople";
import ProductDeatails from "../Components/Products/ProductDeatails";
import DealDetails from "../Components/Deals/DealDetails";
import ActivityDetails from "../Components/Activitys/ActivityDetails";
import ProjectDetails from "../Components/Projects/ProjectDetails";
import ProjectArchive from "../Components/Projects/ProjectArchive";
import ProjectTask from "../Components/Projects/ProjectTask";
import ProjectTemplates from "../Components/Projects/ProjectTemplates";
import AddTemplates from "../Components/Projects/AddTemplates";
import ChatbotComponent from "../Components/Chatbot/Chatbot";
import AddChatbotComponent from "../Components/Chatbot/Chatbot_Add";
import ChatBootDetails from "../Components/Chatbot/ChatBootDetails";
import OrganizationTimeline from "../Components/Contacts/OrganizationTimeline";
import PeopleTimeline from "../Components/Contacts/PeopleTimeline";
import Rules from "../Components/Seetings/AutoAssignment/Rules/Rules";
import Automations from "../Components/Seetings/Automations/Automations";
import ImportData from "../Components/Seetings/ImportData/ImportData ";
import ExportFile from "../Components/Seetings/ExportData/ExportFile";
import WebHooks from "../Components/Seetings/WebHooks/WebHooks";
import Email from "../Components/Email/Email";
import User from "../Components/Customber/User";
import UserRole from "../Components/Customber/UserRole/UserRole";
import OrganizationsDNS from "../Components/OrganizationsDNS/OrganizationsDNS";
import Loading from "../Components/Common/Loading";
import WebFormRoutes from "../Components/Leads/WebForms/WebFormRoutes";
import ChatbotRoutes from "../Components/Chatbot/ChatbotRoutes";
import CommonLayout from "../Components/Common/CommonLayout";

const LayoutPage = ({ Component, ...props }) => <Component {...props} />;

const protectedRoutes = [
  { path: "Analytics", component: Analytics },
  { path: "CRM", component: CRM },
  { path: "Project", component: Project },
  { path: "Ecommerce", component: Ecommerce },
  { path: "Helpdesk", component: Helpdesk },
  { path: "LeadInbox", component: Inbox },
  { path: "LiveChat", component: LiveChat },
  { path: "ChatBot", component: ChatbotComponent },
  { path: "ChatBot/create", component: AddChatbotComponent },
  { path: "ChatBot/create/:id", component: ChatBootDetails },
  { path: "WebForms", component: WebForms },
  { path: "WebForms/Addwebform", component: AddWebForm },
  { path: "WebForms/createForm", component: AllForms },
  { path: "WebForms/createForm/:id", component: AllForms },
  { path: "Prospector", component: Prospector },
  { path: "WebVisitor", component: WebVisitors },
  { path: "Messenger", component: Messenger },
  { path: "Deals", component: Deals },
  { path: "Projects", component: Projects },
  { path: "Projects/:id", component: ProjectDetails },
  { path: "Projects/archive", component: ProjectArchive },
  { path: "Projects/tasks", component: ProjectTask },
  { path: "Projects/Templates", component: ProjectTemplates },
  { path: "Projects/Templates/:id", component: AddTemplates },
  { path: "Campaigns", component: Campaigns },
  { path: "Email-Campaigns", component: EmailCampaigns },
  { path: "Automated-Campaigns", component: AutomatedCampaigns },
  { path: "Email-Templates", component: EmailTemplates },
  { path: "Campaigns-Settings", component: Settings },
  { path: "Alerts-Tips", component: AlertsTips },
  { path: "FindHelp", component: FindHelp },
  { path: "About-Price", component: AboutPrice },
  { path: "Profile", component: Profile },
  { path: "Tour", component: Tour },
  { path: "Timeline", component: Timeline },
  { path: "Treeview", component: Treeview },
  { path: "Starter", component: Starter },
  { path: "Pricing", component: Pricing },
  { path: "Blogs", component: Blogs },
  { path: "FAQs", component: FAQs },
  { path: "Gallery", component: Gallery },
  { path: "Products", component: Products },
  { path: "Marketplace", component: Marketplace },
  { path: "Contact-People", component: People },
  { path: "People-Timeline", component: PeopleTimeline },
  { path: "Contact-Organizations", component: Organizations },
  { path: "Organization-Timeline", component: OrganizationTimeline },
  { path: "activity", component: Activitys },
  { path: "detailsLead/:id", component: InfoDetailsLeads },
  { path: "detailsOrganization/:id", component: DetailsOrganization },
  { path: "detailsPeople/:id", component: DetailsPeople },
  { path: "products/:id", component: ProductDeatails },
  { path: "deal/:id", component: DealDetails },
  { path: "activitys/:id", component: ActivityDetails },
  { path: "settings/auto_assignment", component: Rules },
  { path: "settings/automation", component: Automations },
  { path: "settings/import-Data", component: ImportData },
  { path: "settings/export", component: ExportFile },
  { path: "settings/webhooks", component: WebHooks },
  { path: "email", component: Email },
  { path: "user", component: User },
  { path: "userRole", component: UserRole },
  { path: "Organizations", component: OrganizationsDNS },
];

const Routing = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [isDark, setIsDark] = useState(false);
  const currentPath = window.location.pathname;
  const storedTab = localStorage.getItem("STabs");
  const initialTab = storedTab ? parseInt(storedTab) : 1;
  const [sidebarOpen, setSidebarOpen] = useState(initialTab);
  const accessDetails = localStorage.getItem("role_access");
  const { user } = useSelector((state) => state.root.auth);
  const isDMSUser = user?.userRoleName === "DMS Users";
  const defaultRoute = isDMSUser ? "/Organizations" : "/Analytics";
  const isWebFormEmbedRoute = /^\/WebForms\/[^/]+\/?$/.test(currentPath);
  const isChatbotEmbedRoute = /^\/Chatbot\/[^/]+\/?$/.test(currentPath);

  const layoutProps = {
    isVisible,
    setIsVisible,
    isDark,
    setIsDark,
    sidebarOpen,
    setSidebarOpen,
  };

  const handleResize = useCallback(() => {
    if (window.innerWidth < 1442) {
      setIsVisible(false);
    } else if (!isVisible) {
      setIsVisible(true);
    }
  }, [isVisible]);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [handleResize, isVisible]);

  if (isWebFormEmbedRoute) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/WebForms/:route" element={<WebFormRoutes />} />
        </Routes>
      </BrowserRouter>
    );
  }

  if (isChatbotEmbedRoute) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/Chatbot/:route" element={<ChatbotRoutes />} />
        </Routes>
      </BrowserRouter>
    );
  }

  if (!accessDetails) {
    return <AuthRoutes isVisible={isVisible} setIsVisible={setIsVisible} />;
  }

  if (accessDetails === "USER") {
    return (
      <div
        className={`${isDark ? "darkbackgroud" : "bg-gray-100"}`}
        style={{
          backgroundImage: `url(${isDark ? bgBodyDark : bgBody})`,
        }}
      >
        <body
          data-sidebar-size={`${isVisible ? "default" : "collapsed"}`}
          data-layout-mode={`${isDark ? "dark" : "light"}`}
          className={`light scroll-smooth ${isDark ? "dark" : " "}`}
        >
          <BrowserRouter>
            <ErrorBoundary>
              <Routes>
                <Route path="*" element={<Navigate to={defaultRoute} />} />
                <Route path="/" element={<Navigate to={defaultRoute} />} />
                <Route path="/register" element={<Navigate to={defaultRoute} />} />
                <Route
                  path="/Forgot-password"
                  element={<Navigate to={defaultRoute} />}
                />
                <Route element={<CommonLayout {...layoutProps} />}>
                  {protectedRoutes.map(({ path, component: Component }) => (
                    <Route
                      key={path}
                      path={path}
                      element={<LayoutPage Component={Component} {...layoutProps} />}
                    />
                  ))}
                </Route>
              </Routes>
            </ErrorBoundary>
          </BrowserRouter>
        </body>
        {/* <Route
            path="/Crypto"
            element={
              <Crypto
                isVisible={isVisible}
                setIsVisible={setIsVisible}
                sidebarOpen={sidebarOpen}
                setSidebarOpen={setSidebarOpen}
              />
            }
          />*/}
      </div>
    );
  }


  return <Loading />;
};

export default Routing;
